// attach an operation prop to payload
export const attachOperationProp = operation => payload => ({
  ...payload,
  operation,
});
